export const MAX_NUMBER_CASES = 5000

export default { MAX_NUMBER_CASES }
